import { z } from 'zod';

import { type Fee, FeeCalcTypeEnum } from 'reservations/booking/types';

export const PER_GUEST = 'per guest';
export const PER_PARTY = 'per party';

const FeeTextEnum = z.enum([PER_GUEST, PER_PARTY]);
type FeeTextType = z.infer<typeof FeeTextEnum>;

export const getFeeText = (calcType: Fee['calcType']): FeeTextType =>
  calcType === FeeCalcTypeEnum.enum.PartySize ? PER_GUEST : PER_PARTY;
